import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from '@app/app-routing.module';
import { DxDrawerModule, DxListModule, DxMenuModule, DxRadioGroupModule } from 'devextreme-angular';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';

@NgModule({
  declarations: [NavbarComponent, FooterComponent],
  imports: [CommonModule, DxMenuModule, AppRoutingModule, DxDrawerModule, DxRadioGroupModule,DxListModule],
  exports: [NavbarComponent, FooterComponent],
})
export class LayoutModule {}
